import { render } from "./LocalDashboard.vue?vue&type=template&id=b4896638&ts=true"
import script from "./LocalDashboard.vue?vue&type=script&lang=ts"
export * from "./LocalDashboard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__